import { type StateCreator } from "zustand";

import { type PaymentState } from "./types";

const initState = {
  payDeposit: false,
};

export const createPaymentState: StateCreator<PaymentState> = (set) => ({
  payment: initState,

  paymentActions: {
    setPayDeposit: (payDeposit: boolean) =>
      set((state) => ({ payment: { ...state.payment, payDeposit } })),
  },
});
